export default {
  props: {
    value: Boolean
  },
  data: () => ({
    name: '',
    isFixed: false
  }),
  methods: {
    handleOpen() {
      this.name = '';
      this.isFixed = false;
    },

    handleClose() {
      this.$emit('input', false);
    },

    handleSave() {
      if (!this.name) {
        this.$message.error('方案名称不可为空');
        return;
      }

      this.$emit('save', {
        name: this.name,
        isFixed: this.isFixed
      });
      this.handleClose();
    }

  },

  beforeDestroy() {
    //页面跳转时移除节点  王敏 2021-12-24
    this.$el.remove();
  }

};